module.exports = __webpack_public_path__ + "img/624.Dirty_ables.b2cb9279.svg";